import React, {Component} from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import Timeline from 'app-ui-componentlibrary/dist/go/components/common/Timeline';
import {checkIfValuesAre} from 'common/utils';
import {Segment} from 'semantic-ui-react';
import {isFemaUser} from 'common/utils';
import _ from 'lodash';
import REST from 'go/requests/rest';
import moment from 'moment-timezone';

const startingPage = 1;

export class HistoryTracker extends Component {
  state = {
    page: startingPage,
    loading: true,
    shouldLoad: false,
    noMoreResults: false,
    historyItems: [],
  };

  componentDidMount() {
    if (this.props.token && this.props.data) {
      this.setState(
        {
          historyItems: [],
        },
        () => {
          this.loadHistory(this.props.data, startingPage);
        }
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.data, this.props.data)) {
      this.setState(
        {
          historyItems: [],
        },
        () => {
          this.loadNewHistory(this.props.data, startingPage);
        }
      );
    }
  }

  loadHistory = (grantNumber, pageToLoad) => {
    const updateState = (hist) => {
      this.setState(
        (prevState) => {
          return {
            historyItems: _.concat(prevState.historyItems, hist),
            page: pageToLoad,
            loading: false,
            noMoreResults:
              hist?.totalCount === 0 ||
              prevState?.historyItems?.length + hist?.history?.length ===
                hist?.totalCount,
          };
        },
        () => {
          window.scrollBy(0, 1);
        }
      );
    };
    this.createHistoryCommon(grantNumber, pageToLoad, updateState);
  };

  loadNewHistory = (grantNumber, pageToLoad) => {
    const updateState = (hist) => {
      this.setState(
        {
          historyItems: hist,
          page: pageToLoad,
          loading: false,
        },
        () => {
          window.scrollBy(0, 1);
        }
      );
    };
    this.createHistoryCommon(grantNumber, pageToLoad, updateState);
  };

  createHistoryCommon = (grantNumber, pageToLoad, updateState) => {
    const {hasFemaPermissions, token} = this.props;
    if (hasFemaPermissions) {
      this.setState({
        loading: true,
        shouldLoad: true,
      });

      REST.history
        .getHistoryByGrantId(token, grantNumber, pageToLoad)
        .then(REST.handler.handleResponse)
        .then((hist) => {
          _.each(hist, (h) => {
            _.set(h, 'entryDate', moment(_.get(h, 'historyDate', '')).unix()); //convert UTC to Epoch in seconds
          });
          updateState(hist);
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            loading: false,
            noMoreResults: true,
          });
        });
    } else {
      this.setState({
        shouldLoad: false,
      });
    }
  };

  handleLoadMore = () => {
    let nextPage = this.state.page + 1;
    this.loadHistory(this.props.data, nextPage);
  };

  render() {
    let {header, id} = this.props;
    let {historyItems, loading, shouldLoad, noMoreResults} = this.state;
    if (!shouldLoad) {
      return <React.Fragment />;
    }

    let hasItems = !checkIfValuesAre([undefined, null, []], historyItems);
    return (
      <Segment>
        <h2 id={id}>{header}</h2>
        {hasItems && (
          <Timeline
            timelineItems={historyItems}
            handleLoadMore={this.handleLoadMore}
            noMoreResults={noMoreResults}
            loading={loading}
          />
        )}
        {!hasItems && loading && <Segment basic loading />}
        {!hasItems && !loading && <div>There is no history for this grant.</div>}
      </Segment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    toggles: state.toggles.toggles,
    hasFemaPermissions: isFemaUser(state.auth.permissions),
  };
};

export default connect(mapStateToProps, null)(connectDynamic(HistoryTracker));
